import { useSelector } from "react-redux";

const useInitials = () => {
  const userData = useSelector((state) => state.refreshToken.data);

  const employee = userData?.employees || userData?.employee || userData || {};
  const firstName =
    employee.first_name || employee.firstName || employee.given_name || "";
  const lastName =
    employee.last_name || employee.lastName || employee.family_name || "";
  const initials = `${String(firstName).trim().charAt(0)}${String(lastName)
    .trim()
    .charAt(0)}`;
  return initials ? initials.toUpperCase() : "NA";
};

export default useInitials;
